/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import useAxiosPrivate from '../../Hooks/useAxiosPrivate';
import {
  BoxWrapper,
  InsideWrapper,
  NewsButton,
  NewsContainer,
  NewsForm,
  NewsHeader,
  NewsInput,
  NewsLabel,
  NewsWrapper,
  FeedbackText,
} from './newsletterElements';
import 'react-quill/dist/quill.snow.css';

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ script: 'sub' }, { script: 'super' }],
    ['blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }, { align: [] }],
    ['link', 'image', 'video'],
    ['clean'],
  ],
};

const NewsletterSection = () => {
  const axiosPrivate = useAxiosPrivate();

  const [title, setTitle] = useState('');
  const [emailData, setEmailData] = useState('');

  const [sending, setSending] = useState(false);
  const [feedback, setFeedback] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!title || !emailData) {
      setFeedback('Please fill all required fields');
      return;
    }

    setSending(true);

    try {
      axiosPrivate.post('/sendNewsletter', JSON.stringify({
        emailData,
        title,
      })).then((res) => {
        if (res.data.status === 'success') setFeedback(res.data?.message);
        else setFeedback(res.data?.message);
        setSending(false);
      }).catch((res) => {
        if (res.response?.data) setFeedback(res.response.data.message);
        else if (res?.data) setFeedback(res.data?.message);
        else setFeedback('No server response');
        setSending(false);
      });
    } catch (err) {
      console.log(err);
      setFeedback('Something went wrong. Please try again later.');
      setSending(false);
    }
  };

  // Error handling
  useEffect(() => {
    setFeedback('');
  }, [emailData, title]);

  return (
    <NewsContainer>
      <NewsWrapper>
        <BoxWrapper>
          <NewsHeader>Create and send newsletters</NewsHeader>
          <NewsForm onSubmit={handleSubmit}>
            <InsideWrapper>
              <NewsLabel htmlFor="title">Type E-mail subject here:</NewsLabel>
              <NewsInput
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Type here..."
                aria-describedby="uidnote"
                type="text"
                name="title"
              />
            </InsideWrapper>
            <InsideWrapper>
              <NewsLabel htmlFor="emailData">Type E-mail text here:</NewsLabel>
              <ReactQuill
                modules={modules}
                theme="snow"
                value={emailData}
                onChange={setEmailData}
              />
            </InsideWrapper>
            <FeedbackText>{feedback}</FeedbackText>
            <NewsButton type="submit" disabled={sending}>{sending ? 'Busy' : 'Send'}</NewsButton>
          </NewsForm>
        </BoxWrapper>
      </NewsWrapper>
    </NewsContainer>
  );
};

export default NewsletterSection;
